import React, { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import { href } from "react-router";
import { addStarToAuthor } from "../../Utility/FrontMatterList";

const AuthorGrouping = ({ handleCancel, editor, show }) => {
  const [authorData, setAuthorData] = useState({
    "contrib-id": "",
    collab: "",
    "given-names": "",
    sep: "",
    surname: "",
    degrees: "",
    correspmail: "",
    corresp: "",
    affid: "",
  });

  const [aff, setAff] = useState([]);

  useEffect(() => {
    let authorgroup = editor?.dom?.select("contrib-group");
    let aff = editor?.dom?.select("aff");

    setAff(aff);

    let children = authorgroup?.[0]?.children;

    if (children) {
      const authors = [];

      Array.from(children).forEach((value) => {
        if (value.tagName?.toLowerCase() !== "contrib") return;

        let contribid = value.querySelector("contrib-id")?.textContent || null;
        let givenname = value.querySelector("given-name")?.textContent || null;
        let surname = value.querySelector("surname")?.textContent || null;
        let correspmail =
          value.querySelector("email")?.textContent ||
          value.querySelector("mail1")?.textContent ||
          null;
        let corresp = value.getAttribute("corresp") === "yes" ? "yes" : "";
        let collab = ""; // if you plan to support this later
        let xrefAffs = [
          ...value.querySelectorAll('xref[ref-type="aff"]'),
          ...value.querySelectorAll('xref[ref-type="author-notes"]'),
        ];

        let xrefAffRids = xrefAffs.map((x) => x?.textContent.trim());

        // console.log(xrefAffRids);

        authors.push({
          "contrib-id": contribid,
          collab: collab,
          "given-names": givenname,
          sep: "",
          surname: surname,
          degrees: "",
          correspmail: correspmail,
          corresp: corresp,
          affid: xrefAffRids,
        });
      });

      // Finally set the full authors array
      setAuthorData(authors);
    }
  }, []);

  // console.log(aff[0]);

  const handleChange = (authorIndex, field, value, subIndex = null) => {
    setAuthorData((prevData) =>
      prevData.map((item, i) => {
        if (i !== authorIndex) return item;

        if (field === "affid" && subIndex !== null) {
          const updatedAffids = [...item.affid];
          updatedAffids[subIndex] = value;
          return {
            ...item,
            affid: updatedAffids,
          };
        }

        return {
          ...item,
          [field]: value,
        };
      })
    );
  };

  console.log(authorData);

  const handleSubmit = () => {
    const dom = editor?.dom;
    const contribGroup = dom?.select("contrib-group")?.[0];

    const contribs = contribGroup?.querySelectorAll("contrib");
    if (!dom || !contribGroup) return;

    let hasEqualContrib = false;

    authorData.forEach((author, i) => {
      let contribNode = contribs?.[i];

      if (author.corresp === "yes") {
        addcorrespauthor(author);
      } else {
        checkCorresAuthor(author);
      }

      if (!contribNode) {
        const contribAttrs = author.corresp === "yes" ? { corresp: "yes" } : {};
        contribNode = dom.create("contrib", contribAttrs);

        const refNode = contribGroup.children[i];
        if (refNode) {
          contribGroup.insertBefore(contribNode, refNode);
        } else {
          contribGroup.appendChild(contribNode);
        }
      } else {
        contribNode.innerHTML = "";
        if (author.corresp === "yes") {
          contribNode.setAttribute("corresp", "yes");
        } else {
          contribNode.removeAttribute("corresp");
        }
      }

      const createTextNode = (tag, value) => {
        if (value) {
          const node = dom.create(tag, {}, value);
          contribNode.appendChild(node);
        }
      };

      createTextNode("contrib-id", author["contrib-id"]);
      createTextNode("collab", author["collab"]);
      if (author["surname"] || author["given-names"]) {
        const nameNode = dom.create("name");
        nameNode.setAttribute("name-style", "western");

        if (author["surname"]) {
          const surnameNode = dom.create("surname", {}, author["surname"]);
          nameNode.appendChild(surnameNode);
        }

        if (author["given-names"]) {
          const givenNameNode = dom.create(
            "given-name",
            {},
            author["given-names"]
          );
          nameNode.appendChild(givenNameNode);
        }

        contribNode.appendChild(nameNode);
      }

      createTextNode("degrees", author["degrees"]);

      // Append xref for each affiliation
      (author.affid || []).forEach((affid) => {
        if (affid === "#") {
          hasEqualContrib = true;

          const xrefNode = dom.create("xref", {
            "ref-type": "author-notes",
            rid: "afn1",
          });
          xrefNode.innerHTML = "#";
          contribNode.appendChild(xrefNode);
        } else {
          const xrefNode = dom.create("xref", {
            href: `#aff-${affid}`,
            "ref-type": "aff",
            rid: `aff-${affid}`,
            "data-mce-href": `#aff-${affid}`,
          });
          xrefNode.innerHTML = affid;
          contribNode.appendChild(xrefNode);
        }
      });
      createTextNode("email", author["correspmail"]);
    });

    // Add author-notes -> fn#afn1 only once if needed
    if (hasEqualContrib) {
      insertEqualContribNote(dom);
    }
    addStarToAuthor(editor);
    handleCancel(); // Close modal
  };

  // ⬇️ Create equal contribution note if missing
  function insertEqualContribNote(dom) {
    const authornotes = dom?.select("author-notes")?.[0];
    if (!authornotes) return;

    const existingFn = dom.select('fn[id="afn1"]', authornotes);
    if (existingFn.length === 0) {
      const sup = dom.create("sup", {}, "#");

      const p = dom.create("p");
      p.appendChild(sup);
      p.appendChild(
        dom.doc.createTextNode("These authors contributed equally")
      );

      const fn = dom.create("fn", { id: "afn1" });
      fn.appendChild(p);

      authornotes.appendChild(fn);
    }
  }

  function addcorrespauthor(author) {
    if (!editor) return;

    const dom = editor.dom;
    let authornotes = dom.select("author-notes")?.[0];

    // If <author-notes> doesn't exist, create it and append to <article-meta>
    if (!authornotes) {
      const articleMeta = dom.select("article-meta")?.[0];
      const contribGroup = dom.select("contrib-group")?.[0];
      if (!articleMeta || !contribGroup) return;

      authornotes = dom.create("author-notes");

      if (contribGroup.nextSibling) {
        articleMeta.insertBefore(authornotes, contribGroup.nextSibling);
      } else {
        articleMeta.appendChild(authornotes);
      }

      // Add <label> when creating author-notes
      const label = dom.create("label", {}, "*");
      authornotes.appendChild(label);
    }

    const newEntry = `${author["given-names"]} ${author.surname}${
      author.correspmail ? `. <email>Email: ${author.correspmail}</email>` : ""
    }`;

    const children = Array.from(authornotes.children);
    const correspTags = children.filter(
      (child) => child.tagName.toLowerCase() === "corresp"
    );
    const labelExists = children.some(
      (child) => child.tagName?.toLowerCase() === "label"
    );

    // Check if the entry already exists in any corresp
    const fullName = `${author["given-names"]} ${author.surname}`
      .replace(/\s+/g, " ")
      .trim();

    // Now check if this fullName exists inside any corresp tag's innerText
    const entryExists = Array.from(correspTags).some((corresp) =>
      corresp.innerText.replace(/\s+/g, " ").includes(fullName)
    );

    if (entryExists) return; // Avoid duplicate entries

    let corresp;
    let labelnode;
    if (correspTags.length === 0) {
      if (!labelExists) {
        labelnode = dom.create("label", {}, "*");
        authornotes.appendChild(labelnode);
      }

      // No corresp tag yet, create first one with label
      corresp = dom.create(
        "corresp",
        {
          "data-lock": "true",
          contenteditable: "true",
        },
        `Corresponding Author: ${newEntry}`
      );
    } else if (
      !correspTags[0].innerText
        .replace(/\s+/g, " ")
        .includes("Corresponding Author")
    ) {
      const existingText = correspTags[0].innerHTML;

      // Clear and reconstruct
      correspTags[0].innerHTML = ""; // clear content
      const label = dom.create("label", {}, "*");
      correspTags[0].appendChild(label);
      correspTags[0].append("Corresponding Author: "); // add text
      correspTags[0].insertAdjacentHTML("beforeend", existingText);
    } else {
      // Add new corresp without repeating label
      corresp = dom.create(
        "corresp",
        {
          "data-lock": "true",
          contenteditable: "true",
        },
        newEntry
      );
    }

    authornotes.appendChild(corresp);

    // Add <sup>*</sup> to the corresponding author in contrib
    const contribGroup = dom.select("contrib-group")?.[0];
    if (!contribGroup) return;

    const contribs = Array.from(contribGroup.querySelectorAll("contrib"));
    for (let contrib of contribs) {
      const given = contrib.querySelector("given-name")?.textContent?.trim();
      const surname = contrib.querySelector("surname");

      if (
        given === author["given-names"].trim() &&
        surname?.textContent?.trim() === author.surname.trim()
      ) {
        // Check if <sup>*</sup> already exists
        const hasAsterisk = Array.from(surname.childNodes).some(
          (node) => node.nodeName === "SUP" && node.textContent === "*"
        );
        if (!hasAsterisk) {
          const sup = dom.create("sup", {}, "*");
          surname.appendChild(sup);
        }
        break;
      }
    }
  }

  function checkCorresAuthor(author) {
    if (!editor) return;

    const dom = editor.dom;
    let authornotes = dom.select("author-notes")?.[0];

    if (!authornotes) return;

    const children = Array.from(authornotes.children);
    const correspTags = children.filter(
      (child) => child.tagName.toLowerCase() === "corresp"
    );

    const fullName = `${author["given-names"]} ${author.surname}`
      .replace(/\s+/g, " ")
      .trim();

    // Find and update the matching corresp
    correspTags.forEach((corresp) => {
      const innerText = corresp.innerText.replace(/\s+/g, " ");
      if (innerText.includes(fullName)) {
        corresp.remove();
      }
    });
  }

  const handleAddAffid = (authorIndex) => {
    setAuthorData((prevData) =>
      prevData.map((item, i) => {
        if (i !== authorIndex) return item;
        const currentAffid = Array.isArray(item.affid) ? item.affid : [];
        return {
          ...item,
          affid: [...currentAffid, ""],
        };
      })
    );
  };

  const handleRemoveAffid = (authorIndex) => {
    setAuthorData((prevData) =>
      prevData.map((item, i) => {
        if (i !== authorIndex) return item;
        const currentAffid = Array.isArray(item.affid) ? item.affid : [];
        if (currentAffid.length === 0) return item;
        return {
          ...item,
          affid: currentAffid.slice(0, -1),
        };
      })
    );
  };

  const emptyAuthor = {
    "contrib-id": "",
    collab: "",
    "given-names": "",
    sep: "",
    surname: "",
    degrees: "",
    corresp: "",
    affid: [""],
  };

  const handleAddAuthor = (index) => {
    setAuthorData((prevData) => {
      const newData = [...prevData];
      newData.splice(index + 1, 0, { ...emptyAuthor }); // insert after current
      return newData;
    });
  };

  const handleRemoveAuthor = (index) => {
    setAuthorData((prevData) => {
      if (prevData.length === 1) return prevData; // Prevent deleting the last row
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  return (
    <div className="w-fit h-fit">
      <CustomModel
        handleCancel={handleCancel}
        heading={"Author Grouping"}
        width={"80%"}
        show={show}
      >
        <div className="flex flex-col">
          <div className="flex flex-col overflow-auto max-h-[500px]">
            {authorData.length > 0 &&
              authorData?.map((data, i) => (
                <div key={i} className="flex gap-2 text-[13px] p-2">
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>contrib-id</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["contrib-id"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "contrib-id", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>COLLAB</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["collab"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "collab", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>given-names</label>
                    <input
                      className="border-[1px] border-grey text-givenname"
                      type="text"
                      value={data["given-names"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "given-names", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>SEP</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["sep"]?.trim()}
                      onChange={(e) => handleChange(i, "sep", e.target.value)}
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>surname</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["surname"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "surname", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>degrees</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["degrees"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "degrees", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>Corresp mail</label>
                    <input
                      className="border-[1px] border-grey"
                      type="text"
                      value={data["correspmail"]?.trim()}
                      onChange={(e) =>
                        handleChange(i, "correspmail", e.target.value)
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>Corresp</label>
                    <input
                      className="border-[1px] border-grey"
                      type="checkbox"
                      // value={data["corresp"] === "yes" ? checked : ""}
                      checked={data["corresp"] === "yes" ? true : false}
                      onChange={(e) =>
                        handleChange(
                          i,
                          "corresp",
                          e.target.checked ? "yes" : ""
                        )
                      }
                    ></input>
                  </div>
                  <div className="flex flex-col gap-2 w-fit max-w-[100px]">
                    <label>AFFID</label>
                    {data.affid.map((affId, j) => (
                      <select
                        key={j}
                        value={affId} // This must exactly match `"#"` if selected
                        onChange={(e) =>
                          handleChange(i, "affid", e.target.value, j)
                        }
                        className="px-5 border border-grey mb-2"
                      >
                        {aff.map((item, idx) => {
                          const labelText =
                            item.querySelector("label")?.textContent?.trim() ||
                            "";
                          return (
                            <option key={idx} value={labelText}>
                              {labelText}
                            </option>
                          );
                        })}
                        <option value="#">#</option>
                      </select>
                    ))}
                  </div>
                  <div className="flex w-fit justify-center items-center gap-2 mt-2 ">
                    <div className="flex mt-2 gap-2">
                      <button
                        className="px-4 py-1 w-fit text-nowrap border border-grey"
                        onClick={() => handleAddAffid(i)}
                      >
                        Aff +
                      </button>
                      <button
                        className="px-4 py-1 w-fit text-nowrap border border-grey"
                        onClick={() => handleRemoveAffid(i)}
                        disabled={data.affid.length === 0}
                      >
                        Aff -
                      </button>
                    </div>
                    <div className="flex justify-end gap-2 mt-2 w-fit">
                      <button
                        className="px-4 py-1 border border-grey text-nowrap"
                        onClick={() => handleAddAuthor(i)}
                      >
                        Add Row
                      </button>
                      <button
                        className="px-4 py-1 border border-grey text-nowrap"
                        onClick={() => handleRemoveAuthor(i)}
                        disabled={authorData.length === 1}
                      >
                        Delete Row
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="ml-auto">
            <div className="flex py-3 ml-auto gap-4">
              <button
                className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
                onClick={() => handleCancel()}
              >
                {" "}
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                onClick={() => handleSubmit()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </CustomModel>
    </div>
  );
};

export default AuthorGrouping;
